import { memo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

const DashboardWidgetEmpty = memo(({ image, title, subtitle, actions }) => {
    const theme = useTheme();

    return (
        <div className="fm-dashboard-widget__empty">
            {image}
            <div className="fm-dashboard-widget__empty-titles">
                <Text type="subtitle1" color={theme.colors.utility.textPrimary}>
                    {title}
                </Text>
                <Text type="caption" color={theme.colors.utility.textSecondary}>
                    {subtitle}
                </Text>
            </div>
            {!!actions?.length && (
                <div className="fm-dashboard-widget__empty-actions">{actions}</div>
            )}
        </div>
    );
});

export default DashboardWidgetEmpty;
